import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { EmitMetric } from '../../Analytics/VisibilityPixel/VisibilityPixel';
import MessagePreviewLoading from '../../Icons/Messages/MessagePreviewLoading';
import { messageTypes } from '../../Includes/variables';
import Button from '../../Input/Button/Button';
import MessageBlock from '../../Messages/MessageBlock/MessageBlock';
import { getFormattedTimestamp } from '../../Utilities/TimeFunctions';
import CardHeader from '../CardHeader/CardHeader';
import { ReactRouterLink } from '../ReactRouterLink';

import './GroupChatPreview.scss';
import { GroupContext, MessageContext } from '../../../contexts/ContextCreator';
import { ButtonTypes } from '../Modals/AdminMenuSection/AdminMenuSection';

const GroupChatPreview = (props) => {
    const groupContext = useContext(GroupContext);
    const {
        isLoggedInUser,
        initialLoad,
        getUsersInfoById,
        getGroupHash,
    } = useContext(MessageContext);
    const { buttonType } = props;

    const { previewMessages: messages, hash } = groupContext?.group;
    const shouldRenderMessages = !!messages?.length;

    const onClick = () => {
        const groupHash = getGroupHash(props.channelKey);
        EmitMetric({
            misc_event_count: 1,
            misc_event_type: 'user-activates-message',
            community_group_hash: groupHash,
        });
        EmitMetric({
            misc_event_count: 1,
            misc_event_type: 'group-homepage-right-rail-group-chat-room-click',
            community_group_hash: groupHash,
        });
    };

    // TODO break into individual components
    const generateButton = () => {
        if (buttonType === ButtonTypes.NORMAL) {
            return (
                <a
                    className="group-chat-link"
                    href={`/groups/${hash}/group-chat`}
                    title="group-chat-preview"
                    onClick={onClick}
                >
                    Go to messages
                </a>
            );
        }
        return (
            <ReactRouterLink to="/group-chat" linkText="group-chat-preview">
                <Button
                    type="purple-medium-white"
                    value="Go to messages"
                    onClick={onClick}
                />
            </ReactRouterLink>
        );
    };

    const renderMessageBlock = (
        { id: messageId, text, user, updated_at: updatedAt },
        index
    ) => {
        const { id, credential, logo, username } = user;
        const userDisplayName = isLoggedInUser(id) ? 'You' : username;
        const timestamp = getFormattedTimestamp(updatedAt);

        return (
            <MessageBlock
                key={`${messageId}-${index}`}
                username={userDisplayName}
                userTitle={credential}
                timeStamp={timestamp}
                messageContent={text}
                src={logo}
                messageType={props.messageType}
                shouldDisableDelete
                user={getUsersInfoById(id)}
                messageId={messageId}
                authorId={id}
                enableHoverOver={false}
                isLoggedInUser={isLoggedInUser}
            />
        );
    };

    const renderEmptyState = () => {
        return (
            <React.Fragment>
                <div className="no-message-body">No messages yet.</div>
                <div className="message-button">{generateButton()}</div>
            </React.Fragment>
        );
    };

    const renderMessages = () => (
        <React.Fragment>
            <div className="wrapper">
                <div className="messages-container">
                    {messages
                        .filter((message) => message.type !== 'deleted')
                        .slice(messages.length - 3)
                        .map(renderMessageBlock)}
                </div>
            </div>
            <div className="message-button">{generateButton()}</div>
        </React.Fragment>
    );

    if (initialLoad) {
        return MessagePreviewLoading;
    }

    return (
        <div className="component-Groups-GroupChatPreview">
            <CardHeader cssClass="border-bottom">Group Chat Room</CardHeader>
            {shouldRenderMessages ? renderMessages() : renderEmptyState()}
        </div>
    );
};

GroupChatPreview.propTypes = {
    /**
     * type of messages channel
     */
    messageType: PropTypes.oneOf([messageTypes.COMMUNITY, messageTypes.GROUP])
        .isRequired,
    /**
     * channel key
     */
    channelKey: PropTypes.string.isRequired,
    /**
     * Button Type
     */
    buttonType: PropTypes.oneOf([
        ButtonTypes.NORMAL,
        ButtonTypes.REACTROUTERLINK,
    ]),
};

GroupChatPreview.defaultProps = {
    buttonType: ButtonTypes.REACTROUTERLINK,
};

export default React.memo(GroupChatPreview);
